import { Component } from '@angular/core';

@Component({
  selector: 'app-no-entry',
  imports: [],
  templateUrl: './no-entry.html',
  styleUrl: './no-entry.scss',
})
export class NoEntry {
  exclaimIcon = 'assets/images/exclaim.svg';
}
